// Local translations
export const T = {
  en_GB: {
    description:
      "Define goal types for this collection. When configured, the Goal Input form shows a required goal-type picker and clients categorize each goal (e.g. Grow your wealth, Retirement).",
    noGoalTypes: 'No goal types configured. Click "Add Goal Type" to create one.',
    label: "Label",
    icon: "Icon",
    order: "Order",
    actions: "Actions",
    addGoalType: "Add Goal Type",
    editGoalType: "Edit Goal Type",
    createDialogDescription:
      "Give the goal type a label (and optionally an icon) shown in the goal-type picker.",
    labelPlaceholder: "e.g., Grow your wealth",
    iconLabel: "Icon (optional)",
    allowedClientTypes: "Allowed for client types",
    allowedClientTypesDescription:
      "Which client types can pick this goal type. At least one must stay selected.",
    clientTypePerson: "Person",
    clientTypeCompany: "Company",
    clientTypeGroup: "Group",
    // QL-375 — whether a goal of this type uses a mandate.
    mandate: "Mandate",
    mandateDescription:
      "When enabled, goals of this type have a mandate and cannot be submitted without one. When disabled, they never have one.",
    mandateHidden: "Disabled",
    mandateRequired: "Enabled",
    save: "Save",
    cancel: "Cancel",
    moveUp: "Move up",
    moveDown: "Move down",
    deleteGoalType: "Delete Goal Type",
    deleteDescription:
      "Are you sure you want to delete this goal type? It can no longer be selected, and existing goals that use it will count as incomplete in flows that require a goal type.",
    delete: "Delete",
    error: "Error",
    failedToAdd: "Failed to add goal type",
    failedToUpdate: "Failed to update goal type",
    failedToDelete: "Failed to delete goal type",
    failedToReorder: "Failed to reorder goal types",
    labelRequired: "Label is required",
  },
  nb_NO: {
    description:
      "Definer måltyper for denne samlingen. Når de er konfigurert, viser målskjemaet en obligatorisk måltypevelger, og kundene kategoriserer hvert mål (f.eks. Bygg formue, Pensjon).",
    noGoalTypes: 'Ingen måltyper konfigurert. Klikk "Legg til måltype" for å opprette en.',
    label: "Etikett",
    icon: "Ikon",
    order: "Rekkefølge",
    actions: "Handlinger",
    addGoalType: "Legg til måltype",
    editGoalType: "Rediger måltype",
    createDialogDescription:
      "Gi måltypen en etikett (og eventuelt et ikon) som vises i måltypevelgeren.",
    labelPlaceholder: "f.eks., Bygg formue",
    iconLabel: "Ikon (valgfritt)",
    allowedClientTypes: "Tillatt for kundetyper",
    allowedClientTypesDescription:
      "Hvilke kundetyper som kan velge denne måltypen. Minst én må være valgt.",
    clientTypePerson: "Person",
    clientTypeCompany: "Bedrift",
    clientTypeGroup: "Gruppe",
    mandate: "Mandat",
    mandateDescription:
      "Når aktivert har mål av denne typen et mandat og kan ikke sendes inn uten et. Når deaktivert har de aldri et.",
    mandateHidden: "Deaktivert",
    mandateRequired: "Aktivert",
    save: "Lagre",
    cancel: "Avbryt",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    deleteGoalType: "Slett måltype",
    deleteDescription:
      "Er du sikker på at du vil slette denne måltypen? Den kan ikke lenger velges, og eksisterende mål som bruker den vil telle som ufullstendige i flyter som krever måltype.",
    delete: "Slett",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til måltype",
    failedToUpdate: "Kunne ikke oppdatere måltype",
    failedToDelete: "Kunne ikke slette måltype",
    failedToReorder: "Kunne ikke endre rekkefølgen på måltyper",
    labelRequired: "Etikett er obligatorisk",
  },
} as const;
